import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import './LeftBarContainer.css';

import ButtonLogin from '../top-bar/ButtonLogin';
import ButtonSettings from './ButtonSettings';

function ConnectedSettingsSection({ isConnected }) {
  return (
    <div className={'flexRow space-between settings-section'}>
      <ButtonLogin showUsername={true} />
      { isConnected && <ButtonSettings style={{cursor: 'pointer'}} /> }
    </div>
  )
}

ConnectedSettingsSection.propTypes = {
  isConnected: PropTypes.bool
}

const SettingsSection = connect(
  state => ({
    isConnected: state.isConnected,
  })
)(ConnectedSettingsSection);

export default SettingsSection;
